// extracted by mini-css-extract-plugin
module.exports = {"Bio":"Bio_Bio__1y6IU"};